export default __webpack_public_path__ + "static/media/Inter.var.a738a131.woff2";